export enum EnumSituacaoSistema {
    Ativo = 0,
    Bloqueado = 1,
    Desativado = 2,
}